import styled from "@emotion/styled";
import type { Wallet } from "@solana/wallet-adapter-react";
import { Breakpoints, CheckboxFilter, ContextButton, makeSimpleFilters } from "@stepfinance/react";
import { Dropdown } from "antd";
import type { CheckboxValueType } from "antd/lib/checkbox/Group";
import type { Key } from "react";

import { ReactComponent as FilterIcon } from "../../../assets/filter.svg";
import { useEnrichedWallet } from "../../../contexts/enrichedWallet";
import { useLanguageContext } from "../../../contexts/language/language";
import { useNFTContext } from "../../../contexts/nft";
import { notify } from "../../../utils/notifications";

interface SelectAndShareTwitterRowProps {
  selectedCollections: CheckboxValueType[];
  onApplyFilters: (selectedKeys: React.Key[]) => void;
}

export const SelectAndShareTwitterRow: React.FC<SelectAndShareTwitterRowProps> = ({
  selectedCollections,
  onApplyFilters,
}) => {
  const { wallet } = useEnrichedWallet();
  const {
    currentLanguageData: {
      pages: { nftGallery },
    },
  } = useLanguageContext();

  const { collectionList } = useNFTContext();

  const filterButtonTitle =
    selectedCollections.length > 1
      ? `${selectedCollections.length} Collections Selected`
      : selectedCollections.length === 1
      ? selectedCollections[0]
      : `${collectionList.length} Collections Selected`;

  return (
    <SelectAndTwitterShareRowOnGallery>
      <Dropdown
        overlay={
          <CheckboxFilter
            filters={makeSimpleFilters(collectionList)}
            selectedKeys={selectedCollections as Key[]}
            setSelectedKeys={onApplyFilters}
            confirm={() => {}}
            close={() => {}}
            prefixCls=""
            visible
            searchable
            notAntD
            searchPlaceholder={nftGallery.searchCollection}
            emptySearchResultsPrompt={nftGallery.noCollectionFound}
          />
        }
        autoFocus
        trigger={["click"]}
      >
        <ContextButton>
          {filterButtonTitle}
          <div style={{ marginLeft: "8px" }}>
            <FilterIcon />
          </div>
        </ContextButton>
      </Dropdown>
      <ContextButton onClick={() => onCopyGalleryClick(wallet, nftGallery.copiedGalleryLink)}>
        {nftGallery.copyLink}
      </ContextButton>
    </SelectAndTwitterShareRowOnGallery>
  );
};

const onCopyGalleryClick = (wallet: Wallet | null, message: string) => {
  if (wallet && wallet.adapter.publicKey) {
    const currentURL =
      window.location.origin +
      `/${window.location.pathname.split("/")[1]}` +
      `/nft?watching=${wallet.adapter.publicKey.toBase58()}`;
    void navigator.clipboard.writeText(currentURL);
    notify({
      message: message,
      type: "success",
    });
  }
};

const SelectAndTwitterShareRowOnGallery = styled.div`
  display: flex;
  justify-content: space-between;

  > * {
    margin: auto 0;
  }

  @media (max-width: ${Breakpoints.S}px) {
    flex-direction: column-reverse;
    > button {
      margin-left: 0;
      margin-bottom: 20px;
    }
    .ant-select {
      width: 100% !important;
    }
  }
`;
